export function getEnumValues<T>(someEnum: any): T[] {
  return Object.keys(someEnum)
    .filter((x) => /^\d+$/.test(x))
    .map((x) => Number(x)) as unknown as T[]
}
